import { useMutation, useRequest } from "../../utils/api"
import { GeneralProps, PaginationProps, ShortMutationConfigType } from "../../utils/api.type"
import { ListMapResponseType } from "../map.type"
import { CreateRobotMapProps, DetailRobotMapResponseType, UpdateRobotMapProps } from "./robot-map.type"

const ENDPOINT_LIST_MAP = '/v1/rms/config/robot-map/'
export const useListConfigRobotMap = (obj = {} as GeneralProps & PaginationProps & {
  building_uuid?: string,
  show_bind?: boolean,
  search?: string
}) => {
  return useRequest<ListMapResponseType>(ENDPOINT_LIST_MAP, {
    ...obj,
    page_size: obj.page_size || 5,
    page: obj.page || 1,
    search: obj.search || undefined,
    building_uuid: obj.building_uuid || undefined,
    show_bind: obj.show_bind
  }, {
    enabled: obj.enabled,
    cacheKey: JSON.stringify(obj),
  })
}

const ENDPOINT_CREATE_ROBOT_MAP = '/v1/rms/config/robot-map/store/'
export const useCreateRobotMapMutation = (options: ShortMutationConfigType) => {
  return useMutation<any, CreateRobotMapProps>(ENDPOINT_CREATE_ROBOT_MAP, {
    ...options,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

const ENDPOINT_DETAIL_MAP = '/v1/rms/config/robot-map/detail/:uuid/'
export const useDetailConfigRobotMap = (uuid: string, options: GeneralProps) => {
  return useRequest<DetailRobotMapResponseType>(ENDPOINT_DETAIL_MAP.replace(':uuid', uuid), {
    ...options
  }, {
    enabled: options.enabled,
    cacheKey: JSON.stringify(options),
  })
}


const ENDPOINT_UPDATE_ROBOT_MAP = '/v1/rms/config/robot-map/update/:uuid/'
export const useUpdateRobotMapMutation = (uuid: string, options: ShortMutationConfigType) => {
  return useMutation<any, UpdateRobotMapProps>(ENDPOINT_UPDATE_ROBOT_MAP.replace(':uuid', uuid), {
    ...options,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}